module.exports = __webpack_public_path__ + "static/img/tool-icon-hot.bd5e7ba7.png";